<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <!-- {{data}} -->
        <!-- {{user}} -->
        <div class="card-body">
          <h5 class="card-title">Información de Proveedor "{{ data.name }}"</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{data.name}} - {{data.siglas}}</h6>
          <h6 class="card-subtitle mb-2 text-muted">{{data.key_provider}}</h6>
          <div class="card mt-5">
            <div class="card-header row">
                <div class="col-lg-6">Información Básica</div>
                <div class="text-right col-lg-6">
                    <button @click="editarInfo" v-if="myRoleId === 1">editar</button>
                </div>
            </div>
             <div class="card-body">
              <div class="row text-center">
                <div class="col-md-4">
                  <h6>Proovedor</h6>
                </div>
                <div class="col-md-4">
                  <h6>Descuento</h6>
                </div>
                <div class="col-md-4">
                  <h6>Descuento al cliente</h6>
                </div>
              </div>
              <div class="row text-center">
                <div class="col-md-4">{{ data.name }}</div>
                <div class="col-md-4">{{ data.discount }} %</div>
                <div class="col-md-4">{{ data.discount_client }} %</div>
              </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="card-header">
              Estado de cuenta
            </div>
            <div class="card-body">
              <div class="row text-center">
                <div class="col-md-4">
                  <h6>Pedidos activos</h6>
                </div>
                <div class="col-md-4">
                  <h6>Piezas en inventario</h6>
                </div>
                <div class="col-md-4">
                  <h6>Total de Venta hoy</h6>
                </div>
              </div>
              <div class="row text-center" v-if="myRoleId === 1">
                <div class="col-md-4">{{ totalOrders }} <br /><a href="#" @click="showDetails('comensales')">ver más</a ></div>
                <div class="col-md-4">{{ data.numero_ordenes_inventario }} <br /><a href="#" @click="showDetails('abonos')">ver más</a ></div>
                <div class="col-md-4">$ {{ data.total_venta_hoy }} <br /><a href="#" @click="showDetails('cargos')">ver más</a ></div>
              </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="card-header">
              Acciones rapidas
            </div>
            <div class="card-body">
               <button class="btn btn-orange mr-4" @click="addDevolution()" v-if="myRoleId === 1">Generar Devolución</button>
               <!-- <button class="btn btn-purple mr-4" @click="AddSales()">Generar Venta</button> -->
               <!-- <button class="btn btn-purple mr-4" @click="AddSales()">Generar Venta</button> -->
               <button class="btn btn-purple mr-4" @click="configDates()">Configurar fechas por mes</button>
               <!-- <button class="btn btn-purple mr-4" @click="setPrint()">Imprimir Contrato</button> -->
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">
              Otros
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">
              Comentarios - Observaciones
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="editInfo" :scrollable="true" height="590" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('editInfo')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="reset-pass">
        <h2 class="text-center">Editar Información</h2>
        <div class="form-group col-11">
           <label for="exampleInputEmail1"><b>Nombre</b></label>
           <input type="text" class="form-control ml-3" v-model="data.name" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nombre">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1"><b>Descuento %</b></label>
            <input type="number" class="form-control ml-3" v-model="data.discount" placeholder="Dirección">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1"><b>Descuento Cliente %</b></label>
            <input type="number" class="form-control ml-3" v-model="data.discount_client" placeholder="Estado">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1"><b>Siglas</b></label>
            <input type="text" class="form-control ml-3" v-model="data.siglas" placeholder="Siglas de proveedor">
        </div>
        <b-form-group class="ml-4 mt-3" label-cols-sm="4" label="Calculo de Precio*" label-for="input-cliet-discount">
          <b-form-checkbox v-model="data.toright" name="check-button" switch>
            Calculo hacia la  <b>{{ data.toright ? 'Derecha' : 'Izquierda'}}</b>
          </b-form-checkbox>
        </b-form-group>
        <div class="text-center">
            <button type="submit" class="btn btn-primary text-center" @click="add">Actualizar</button>
        </div>
      </div>
    </modal>
    <modal name="devolutions" :scrollable="true" height="auto" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('devolutions')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="reset-pass">
        <h2 class="text-center">Generar Devoluciones</h2>
        <div class="container row mt-5 justify-content-center">
          <input ref="searchBarcode" class="inputBarCode" type="text" v-model="barcodeSearch" placeholder="Codigo de barras" min="0" v-on:keyup.enter="searchElement"/>
        </div>
        <div class="container row justify-content-center mt-3 mb-3" v-if="(escaneadosNo > 0)">
          <div class="col-lg-10 mt-4 text-center row justify-content-center">
          <div class="col-lg-6 table-primary">
            <b>Piezas escaneadas: {{escaneadosNo}}</b>
          </div>
          <div class="col-lg-6 table-secondary">
            <b>Total escaneadas: $ {{escaneadosTotal | formatNumberCurrency}}</b>
          </div>
        </div>
        </div>
        <div class="container row justify-content-center mt-3 mb-5">
          <div class="col-lg-10">
            <b-table striped hover :items="ordersScann"></b-table>
          </div>
        </div>
        <div class="row justify-content-center mb-4">
            <button type="submit" class="btn btn-primary" @click="registerDevolution">Generar Devolución</button>
        </div>
      </div>
    </modal>
    <modal
      name="datesForMonths"
      class="modals"
      :adaptive="true"
      classes="demo-modal-class"
      :scrollable="true"
      :reset="true"
      width="800px"
      height="700px"
    >
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('datesForMonths')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="mb-5">
        <h2 class="text-center">Editar fechas por mes</h2>
        <div class="row justify-content-center mb-5">
          <div class="col-lg-1">
            <div class="form-group col-lg-1">
              <label>
                <b>Mes</b>
                <span class="required">*</span>
              </label>
            </div>
            </div>
          <div class="col-lg-5">
            <multiselect
              v-model="mesSeleccionado"
              :options="mes"
              :searchable="true"
              :close-on-select="true"
              :allow-empty="false"
              :show-labels="false"
              label="name"
              placeholder="Mes"
              required
            />
          </div>
          <div class="col-lg-6 text-center">
            <button type="submit" v-if="rows.length > 0" class="btn btn-primary text-center" @click="addDatesMonth">Guardar fechas de {{mesSeleccionado.name}}</button>
          </div>
        </div>
        <div class="size-modal-content" v-if="mesSeleccionado !== ''">
          <div class="row justify-content-center mb-1" >
            <div class="col-lg-8 text-center mt-2 mb-5">
              <date-range-picker
                v-model="rowsDatesforMonth"
                opens="center"
                :autoApply="true"
                singleDatePicker="range"
                :show-ranges="false"
                :linkedCalendars="false"
                :ranges="false"
                :show-dropdowns="true"
                :drops="true"
              />
            </div>
            <div class="col-lg-3 text-center">
              <button class="btn-purple" @click="addRowCalendar">+</button>
            </div>
          </div>
          <div class="row justify-content-center"  style="height: 25em; overflow-x: hidden; overflow-y: scroll;">
            <!-- {{rows}} -->
             <vue-good-table
                mode="remote"
                :columns="colums"
                :rows="rows"
                :sort-options="{
                    enabled: true,
                    initialSortBy: [{field: 'name', type: 'asc'}]
                }"
                :isLoading.sync="isLoading"
                styleClass="vgt-table bordered"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'actions'">
                    <button class="btn btn-orange" @click="eliminarFecha(props.row)">Eliminar</button>
                  </span>
                </template>
              </vue-good-table>
          </div>
        </div>
        <div class="row justify-content-center mt-5" style="margin-top:160px !important;">
          <div class="col-lg-6 text-center mt-5">
            <button type="submit" v-if="rows.length > 0" class="btn btn-primary text-center" @click="addDatesMonth">Guardar fechas de {{mesSeleccionado.name}}</button>
          </div>
        </div>
      </div>
      <div
        slot="top-right"
        class="ct-top-right"
        @click="$modal.hide('dog-profile')"
      >
      Slot for close button
    </div>
    </modal>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import { mapGetters } from 'vuex'
import {
  BFormGroup,
  BFormCheckbox,
  BTable
} from 'bootstrap-vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import 'moment-timezone'
// moment().tz('America/Mexico_City').format()
moment.locale('es')
export default {
  mixins: [formatData],
  components: {
    BFormGroup,
    BFormCheckbox,
    DateRangePicker,
    BTable
  },
  data () {
    return {
      ordersScann: [],
      barcodeSearch: '',
      today: moment().format('YYYY-MM-DD'),
      startSelectionDate: moment().format('YYYY-MM-DD'),
      rowsDatesforMonth: {
        startDate: '2019-12-10',
        endDate: '2019-12-20'
      },
      pickerDates: {
        startDate: new Date(),
        endDate: new Date()
      },
      opens: 'center',
      minDate: '2019-05-02 04:00:00',
      maxDate: '2020-12-26 14:00:00',
      // minDate: '',
      // maxDate: '',
      dateRange: {
        startDate: '2019-12-10',
        endDate: '2019-12-20'
      },
      single_range_picker: false,
      show_ranges: true,
      singleDatePicker: false,
      timePicker: true,
      timePicker24Hour: true,
      showDropdowns: true,
      autoApply: false,
      showWeekNumbers: true,
      linkedCalendars: true,
      alwaysShowCalendars: true,
      appendToBody: false,
      closeOnEsc: true,
      mesSeleccionado: '',
      totalOrders: 0,
      ordenesActivas: 0,
      showComensales: false,
      showAbonos: false,
      showCargos: false,
      comensales: [],
      cargos: [],
      abonos: [],
      data: [],
      contrato: '',
      mes: [{ value: 1, name: 'Enero' }, { value: 2, name: 'Febrero' }, { value: 3, name: 'Marzo' }, { value: 4, name: 'Abril' }, { value: 5, name: 'Mayo' }, { value: 6, name: 'Junio' }, { value: 7, name: 'Julio' }, { value: 8, name: 'Agosto' }, { value: 9, name: 'Septiembre' }, { value: 10, name: 'Octubre' }, { value: 11, name: 'Noviembrre' }, { value: 12, name: 'Diciembre' }],
      titleModal: '',
      editInfo: {
        name: '',
        lastname1: '',
        lastname2: '',
        address: '',
        phone: '',
        email: '',
        right: false
      },
      colums: [
        {
          label: 'Rango de Fechas',
          field: 'name'
        },
        // {
        //   label: 'Fecha final',
        //   field: 'endDate'
        // },
        {
          label: 'Acciones',
          field: 'actions',
          formatFn: this.formatCurrencyX
        }
      ],
      isLoading: false,
      rows: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    escaneadosNo () {
      return this.ordersScann.length
    },
    escaneadosTotal () {
      let total = 0
      this.ordersScann.forEach(el => {
        total += el.costo_tienda
      })
      return total
    },
    myRoleId () {
      return this.$store.getters.currentRoleId
    }
  },
  methods: {
    async addDatesMonth () {
      try {
        const dates = []
        this.rows.forEach(el => {
          console.log(moment().format('l'), el)
          const init = moment(el.startDate).format('DD')
          const end = moment(el.endDate).format('DD')
          const initMonth = moment(el.startDate).format('MMMM')
          const endMonth = moment(el.endDate).format('MMMM')
          let entry = ''
          if (initMonth !== endMonth) {
            entry = initMonth
          }
          const name = init + (entry !== '' ? ' DE ' + initMonth : '') + ' AL ' + end + ' DE ' + endMonth
          console.log('name', name.toUpperCase())
          dates.push({
            startDate: moment(el.startDate).format('YYYY-MM-DD'),
            endDate: moment(el.endDate).format('YYYY-MM-DD'),
            name: name.toUpperCase()
          })
        })
        const request = {
          month: this.mesSeleccionado.value,
          year: moment().format('YYYY'),
          provider_id: this.data.id_provider,
          enterprise_id: this.user.enterprise_id,
          data: dates
        }
        console.log('request', request)
        const response = await axiosAdelaService.post('/addDatesMonth', request)
        console.log('addDatesMonth', response)
        if (response.status === 200) {
          this.$toastedPush({
            message: 'Fechas agregadas correctamente',
            type: 'success'
          })
          this.$modal.hide('datesForMonths')
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    logEvent (...args) {
      console.log(...args)
    },
    configDates () {
      this.mesSeleccionado = ''
      this.rowsDatesforMonth = []
      this.$modal.show('datesForMonths')
    },
    async add () {
      try {
        const request = {
          name: this.data.name,
          discount: this.data.discount,
          discount_client: this.data.discount_client,
          provider_id: this.data.id_provider,
          siglas: this.data.siglas
        }
        console.log('Solicitud', request)
        const abonos = await axiosAdelaService.post('/updateProvider', request)
        if (abonos.status === 200) {
          this.$toastedPush({
            message: 'Proveedor actualizado correctamente',
            type: 'success'
          })
          this.$modal.hide('editInfo')
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getInfoProvider () {
      try {
        const request = {
          provider_id: this.data.id_provider
        }
        const enterprise = await axiosAdelaService.post('/getInfoProvider', request)
        console.log('getInfoProvider', enterprise)
        if (enterprise.status === 200) {
          this.data = enterprise.data.provider_info
          this.data.toright = parseInt(this.data.toright) === 1
          this.totalOrders = enterprise.data.totalOrders
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    AddOrder () {
      this.$router.push({ name: 'addOrders' })
    },
    AddSales () {
      this.$router.push({ name: 'addsales' })
    },
    editarInfo () {
      this.$modal.show('editInfo')
    },
    addRowCalendar () {
      console.log('endOf(month)', moment(this.startSelectionDate).endOf('month').format('YYYY-MM-DD'))
      const init = moment(this.rowsDatesforMonth.startDate).format('DD')
      const end = moment(this.rowsDatesforMonth.endDate).format('DD')
      const initMonth = moment(this.rowsDatesforMonth.startDate).format('MMMM')
      const endMonth = moment(this.rowsDatesforMonth.endDate).format('MMMM')
      let entry = ''
      if (initMonth !== endMonth) {
        entry = initMonth
      }
      const name = init + (entry !== '' ? ' DE ' + initMonth : '') + ' AL ' + end + ' DE ' + endMonth
      this.rows.push({
        startDate: moment(this.rowsDatesforMonth.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.rowsDatesforMonth.endDate).format('YYYY-MM-DD'),
        name: name,
        id: this.rows.length
      })
    },
    async getRelationDates () {
      try {
        this.rows = []
        const request = {
          month: this.mesSeleccionado.value,
          year: moment().format('YYYY'),
          provider_id: this.data.id_provider,
          enterprise_id: this.user.enterprise_id
        }
        const enterprise = await axiosAdelaService.post('/getRelationDates', request)
        console.log('getRelationDates', enterprise)
        if (enterprise.status === 200) {
          this.isLoading = false
          if (enterprise.data.rows.length > 0) {
            enterprise.data.rows.forEach(el => {
              this.rows.push({
                startDate: moment(el.date_init).format('YYYY-MM-DD'),
                endDate: moment(el.date_end).format('YYYY-MM-DD'),
                name: el.name,
                id: this.rows.length
              })
            })
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    eliminarFecha (arg) {
      console.log('Eliminar', arg)
      const temp = this.rows.filter(el => el.id !== arg.id)
      this.rows = temp
    },
    addDevolution () {
      this.$modal.show('devolutions')
    },
    async searchElement () {
      const request = {
        barcode: this.barcodeSearch,
        enterprise: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getOrderByBarcode', request)
      console.log(response)
      if (response.status === 200) {
        if (response.data.totalRecords > 0) {
          const data = response.data.rows[0]
          const exist = this.ordersScann.find(el => el.id_order === data.id_order)
          if (exist === undefined) {
            if (data.provider_id === this.data.id_provider) {
              this.ordersScann.push({
                id: data.id_order,
                codigo_barras: data.barcode,
                producto: data.product,
                cantidad: data.cantidad,
                costo_tienda: '$ ' + this.$formatNumberCurrency(data.costo_tienda)
              })
            } else {
              this.$toastedPush({
                message: 'Este producto no pertenece a este proveedor, por favor verifique sus datos...',
                type: 'error'
              })
            }
          } else {
            this.$toastedPush({
              message: 'Este producto ya fue registrado, verifique sus datos..',
              type: 'error'
            })
          }
        }
      }
      this.barcodeSearch = ''
    },
    async registerDevolution () {
      try {
        this.rows = []
        const request = {
          orders: this.ordersScann,
          provider_id: this.data.id_provider,
          enterprise_id: this.user.enterprise_id
        }
        console.log('addDevolutionProvider', request)
        const enterprise = await axiosAdelaService.post('/addDevolutionProvider', request)
        console.log('getRelationDates', enterprise)
        if (enterprise.status === 200) {
          if (enterprise.data.affectedRows > 0) {
            this.ordersScann = []
            this.$toastedPush({
              message: 'Devolucion realizada correctamente...',
              type: 'success'
            })
          } else {
            this.$toastedPush({
              message: 'Algo ocurrio intentelo mas tarde..',
              type: 'error'
            })
          }
          this.$modal.hide('devolutions')
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    }
  },
  watch: {
    async mesSeleccionado (arg) {
      const year = moment().format('YYYY')
      const diasMes = moment(year + '-' + arg.value + '-01').daysInMonth()
      console.log('mesSeleccionado', arg, moment(year + '-' + arg.value + '-01').daysInMonth())
      const startOfMonth = moment().startOf('month').format(year + '-' + arg.value + '-01')
      const endOfMonth = moment().endOf('month').format(year + '-' + arg.value + '-' + diasMes)
      console.log('Fecha inicio', startOfMonth)
      console.log('Fecha Final', endOfMonth)
      this.startSelectionDate = moment(year + '-' + arg.value + '-01').format('YYYY-MM-DD')
      this.rowsDatesforMonth.startDate = startOfMonth
      this.rowsDatesforMonth.endDate = endOfMonth
      await this.getRelationDates()
    }
  },
  async mounted () {
    try {
      this.data = this.$route.params
      console.log('Parametros', this.$route.params)
      await this.getInfoProvider()
    } catch (error) {
      this.showError('No se pudieron obtener los datos intentalo mas tarde.')
    }
  }
}
</script>

<style>
</style>
